import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { createUserWithEmailAndPassword, getAuth, signInWithEmailAndPassword } from '@angular/fire/auth';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DroneStore } from 'src/app/data-stores/drone-store';

@Component({
  selector: 'app-home',
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  email: string = ''
  password: string = ''

  firstName: string = ''
  lastName: string = ''

  drones: any[] = []
  loaded: boolean = false

  constructor(private router: Router, private droneStore: DroneStore) {}

  create() {
    if (this.email == '' || this.password == '') {
      return
    }

    createUserWithEmailAndPassword(getAuth(), this.email, this.password)
      .then((userCredential) => {
        const user = userCredential.user
        alert('Created...')
      })
  }

  signIn() {
    if (this.email == '' || this.password == '') {
      return
    }

    signInWithEmailAndPassword(getAuth(), this.email, this.password).then((userCredential: any) => {
      this.router.navigate(['/drones'])
    })
  }

}
